import { useEffect, useRef } from 'react';

const SVG_HTML = `
  <image href="/assets/sttora-global-clean.png" x="0" y="0" width="1792" height="768" preserveAspectRatio="xMidYMid meet" />

  <circle class="origin-halo" cx="743" cy="514" r="16" />
  <circle class="map-point origin-point" cx="743" cy="514" r="8" />
  <circle class="map-point" cx="658" cy="393" r="5" />
  <circle class="map-point" cx="705" cy="332" r="5" />
  <circle class="map-point" cx="660" cy="253" r="5" />
  <circle class="map-point" cx="789" cy="470" r="5" />
  <circle class="map-point" cx="977" cy="316" r="5" />
  <circle class="map-point" cx="1022" cy="261" r="5" />
  <circle class="map-point" cx="1016" cy="180" r="5" />
  <circle class="map-point" cx="1125" cy="336" r="5" />
  <circle class="map-point" cx="1137" cy="243" r="5" />
  <circle class="map-point" cx="1022" cy="403" r="5" />
  <circle class="map-point" cx="1050" cy="512" r="5" />
  <circle class="map-point" cx="837"  cy="553" r="5" />
  <circle class="map-point" cx="791"  cy="618" r="5" />

  <path id="route-1"  class="route-line" d="M743 514 C710 472 680 430 658 393" />
  <path id="route-2"  class="route-line" d="M743 514 C720 455 705 390 705 332" />
  <path id="route-3"  class="route-line" d="M743 514 C705 420 675 330 660 253" />
  <path id="route-4"  class="route-line" d="M743 514 C758 500 775 485 789 470" />
  <path id="route-5"  class="route-line" d="M743 514 C805 420 890 350 977 316" />
  <path id="route-6"  class="route-line" d="M743 514 C820 395 915 305 1022 261" />
  <path id="route-7"  class="route-line" d="M743 514 C805 360 900 230 1016 180" />
  <path id="route-8"  class="route-line" d="M743 514 C865 430 1000 360 1125 336" />
  <path id="route-9"  class="route-line" d="M743 514 C850 365 995 270 1137 243" />
  <path id="route-10" class="route-line" d="M743 514 C825 460 930 415 1022 403" />
  <path id="route-11" class="route-line" d="M743 514 C845 500 955 500 1050 512" />
  <path id="route-12" class="route-line" d="M743 514 C775 525 805 542 837 553" />
  <path id="route-13" class="route-line" d="M743 514 C750 560 765 596 791 618" />

  <g class="beam" opacity="0">
    <ellipse class="beam-tail-soft" cx="-13" cy="0" rx="14" ry="2.8"></ellipse>
    <ellipse class="beam-tail-core" cx="-9" cy="0" rx="10" ry="1.8"></ellipse>
    <ellipse class="beam-body" cx="-2" cy="0" rx="7" ry="1.15"></ellipse>
    <circle class="beam-head-glow" cx="4" cy="0" r="2.6"></circle>
    <circle class="beam-head-core" cx="4.4" cy="0" r="1.25"></circle>
    <animate attributeName="opacity" values="0;0.88;0.88;0" dur="7.4s" repeatCount="indefinite" begin="0s" />
    <animateMotion dur="7.4s" repeatCount="indefinite" begin="0s" rotate="auto"><mpath href="#route-1" /></animateMotion>
  </g>
  <g class="beam" opacity="0">
    <ellipse class="beam-tail-soft" cx="-13" cy="0" rx="14" ry="2.8"></ellipse>
    <ellipse class="beam-tail-core" cx="-9" cy="0" rx="10" ry="1.8"></ellipse>
    <ellipse class="beam-body" cx="-2" cy="0" rx="7" ry="1.15"></ellipse>
    <circle class="beam-head-glow" cx="4" cy="0" r="2.6"></circle>
    <circle class="beam-head-core" cx="4.4" cy="0" r="1.25"></circle>
    <animate attributeName="opacity" values="0;0.88;0.88;0" dur="8s" repeatCount="indefinite" begin="0.8s" />
    <animateMotion dur="8s" repeatCount="indefinite" begin="0.8s" rotate="auto"><mpath href="#route-2" /></animateMotion>
  </g>
  <g class="beam" opacity="0">
    <ellipse class="beam-tail-soft" cx="-14" cy="0" rx="15" ry="2.9"></ellipse>
    <ellipse class="beam-tail-core" cx="-9.5" cy="0" rx="10.5" ry="1.85"></ellipse>
    <ellipse class="beam-body" cx="-2" cy="0" rx="7.4" ry="1.2"></ellipse>
    <circle class="beam-head-glow" cx="4.2" cy="0" r="2.7"></circle>
    <circle class="beam-head-core" cx="4.6" cy="0" r="1.28"></circle>
    <animate attributeName="opacity" values="0;0.88;0.88;0" dur="8.8s" repeatCount="indefinite" begin="1.6s" />
    <animateMotion dur="8.8s" repeatCount="indefinite" begin="1.6s" rotate="auto"><mpath href="#route-3" /></animateMotion>
  </g>
  <g class="beam" opacity="0">
    <ellipse class="beam-tail-soft" cx="-11.5" cy="0" rx="12.2" ry="2.45"></ellipse>
    <ellipse class="beam-tail-core" cx="-8" cy="0" rx="8.6" ry="1.6"></ellipse>
    <ellipse class="beam-body" cx="-1.7" cy="0" rx="6.2" ry="1.02"></ellipse>
    <circle class="beam-head-glow" cx="3.7" cy="0" r="2.35"></circle>
    <circle class="beam-head-core" cx="4.1" cy="0" r="1.16"></circle>
    <animate attributeName="opacity" values="0;0.82;0.82;0" dur="5.8s" repeatCount="indefinite" begin="2.1s" />
    <animateMotion dur="5.8s" repeatCount="indefinite" begin="2.1s" rotate="auto"><mpath href="#route-4" /></animateMotion>
  </g>
  <g class="beam" opacity="0">
    <ellipse class="beam-tail-soft" cx="-14" cy="0" rx="15" ry="2.9"></ellipse>
    <ellipse class="beam-tail-core" cx="-9.5" cy="0" rx="10.5" ry="1.85"></ellipse>
    <ellipse class="beam-body" cx="-2" cy="0" rx="7.4" ry="1.2"></ellipse>
    <circle class="beam-head-glow" cx="4.2" cy="0" r="2.7"></circle>
    <circle class="beam-head-core" cx="4.6" cy="0" r="1.28"></circle>
    <animate attributeName="opacity" values="0;0.88;0.88;0" dur="9.2s" repeatCount="indefinite" begin="0.5s" />
    <animateMotion dur="9.2s" repeatCount="indefinite" begin="0.5s" rotate="auto"><mpath href="#route-5" /></animateMotion>
  </g>
  <g class="beam" opacity="0">
    <ellipse class="beam-tail-soft" cx="-14" cy="0" rx="15" ry="2.9"></ellipse>
    <ellipse class="beam-tail-core" cx="-9.5" cy="0" rx="10.5" ry="1.85"></ellipse>
    <ellipse class="beam-body" cx="-2" cy="0" rx="7.4" ry="1.2"></ellipse>
    <circle class="beam-head-glow" cx="4.2" cy="0" r="2.7"></circle>
    <circle class="beam-head-core" cx="4.6" cy="0" r="1.28"></circle>
    <animate attributeName="opacity" values="0;0.88;0.88;0" dur="9.8s" repeatCount="indefinite" begin="1.2s" />
    <animateMotion dur="9.8s" repeatCount="indefinite" begin="1.2s" rotate="auto"><mpath href="#route-6" /></animateMotion>
  </g>
  <g class="beam" opacity="0">
    <ellipse class="beam-tail-soft" cx="-14.4" cy="0" rx="15.4" ry="3"></ellipse>
    <ellipse class="beam-tail-core" cx="-9.8" cy="0" rx="10.8" ry="1.9"></ellipse>
    <ellipse class="beam-body" cx="-2.1" cy="0" rx="7.6" ry="1.22"></ellipse>
    <circle class="beam-head-glow" cx="4.25" cy="0" r="2.75"></circle>
    <circle class="beam-head-core" cx="4.65" cy="0" r="1.3"></circle>
    <animate attributeName="opacity" values="0;0.88;0.88;0" dur="10.5s" repeatCount="indefinite" begin="2.2s" />
    <animateMotion dur="10.5s" repeatCount="indefinite" begin="2.2s" rotate="auto"><mpath href="#route-7" /></animateMotion>
  </g>
  <g class="beam" opacity="0">
    <ellipse class="beam-tail-soft" cx="-14.4" cy="0" rx="15.4" ry="3"></ellipse>
    <ellipse class="beam-tail-core" cx="-9.8" cy="0" rx="10.8" ry="1.9"></ellipse>
    <ellipse class="beam-body" cx="-2.1" cy="0" rx="7.6" ry="1.22"></ellipse>
    <circle class="beam-head-glow" cx="4.25" cy="0" r="2.75"></circle>
    <circle class="beam-head-core" cx="4.65" cy="0" r="1.3"></circle>
    <animate attributeName="opacity" values="0;0.88;0.88;0" dur="10.8s" repeatCount="indefinite" begin="3s" />
    <animateMotion dur="10.8s" repeatCount="indefinite" begin="3s" rotate="auto"><mpath href="#route-8" /></animateMotion>
  </g>
  <g class="beam" opacity="0">
    <ellipse class="beam-tail-soft" cx="-14.8" cy="0" rx="15.8" ry="3.05"></ellipse>
    <ellipse class="beam-tail-core" cx="-10" cy="0" rx="11" ry="1.95"></ellipse>
    <ellipse class="beam-body" cx="-2.2" cy="0" rx="7.8" ry="1.24"></ellipse>
    <circle class="beam-head-glow" cx="4.35" cy="0" r="2.82"></circle>
    <circle class="beam-head-core" cx="4.75" cy="0" r="1.32"></circle>
    <animate attributeName="opacity" values="0;0.88;0.88;0" dur="11.2s" repeatCount="indefinite" begin="3.6s" />
    <animateMotion dur="11.2s" repeatCount="indefinite" begin="3.6s" rotate="auto"><mpath href="#route-9" /></animateMotion>
  </g>
  <g class="beam" opacity="0">
    <ellipse class="beam-tail-soft" cx="-13.2" cy="0" rx="14.2" ry="2.75"></ellipse>
    <ellipse class="beam-tail-core" cx="-9" cy="0" rx="10" ry="1.78"></ellipse>
    <ellipse class="beam-body" cx="-2" cy="0" rx="7" ry="1.14"></ellipse>
    <circle class="beam-head-glow" cx="4" cy="0" r="2.58"></circle>
    <circle class="beam-head-core" cx="4.4" cy="0" r="1.24"></circle>
    <animate attributeName="opacity" values="0;0.86;0.86;0" dur="9s" repeatCount="indefinite" begin="4.1s" />
    <animateMotion dur="9s" repeatCount="indefinite" begin="4.1s" rotate="auto"><mpath href="#route-10" /></animateMotion>
  </g>
  <g class="beam" opacity="0">
    <ellipse class="beam-tail-soft" cx="-13.2" cy="0" rx="14.2" ry="2.75"></ellipse>
    <ellipse class="beam-tail-core" cx="-9" cy="0" rx="10" ry="1.78"></ellipse>
    <ellipse class="beam-body" cx="-2" cy="0" rx="7" ry="1.14"></ellipse>
    <circle class="beam-head-glow" cx="4" cy="0" r="2.58"></circle>
    <circle class="beam-head-core" cx="4.4" cy="0" r="1.24"></circle>
    <animate attributeName="opacity" values="0;0.84;0.84;0" dur="9.6s" repeatCount="indefinite" begin="4.8s" />
    <animateMotion dur="9.6s" repeatCount="indefinite" begin="4.8s" rotate="auto"><mpath href="#route-11" /></animateMotion>
  </g>
  <g class="beam" opacity="0">
    <ellipse class="beam-tail-soft" cx="-11.5" cy="0" rx="12.2" ry="2.45"></ellipse>
    <ellipse class="beam-tail-core" cx="-8" cy="0" rx="8.6" ry="1.6"></ellipse>
    <ellipse class="beam-body" cx="-1.7" cy="0" rx="6.2" ry="1.02"></ellipse>
    <circle class="beam-head-glow" cx="3.7" cy="0" r="2.35"></circle>
    <circle class="beam-head-core" cx="4.1" cy="0" r="1.16"></circle>
    <animate attributeName="opacity" values="0;0.82;0.82;0" dur="6.2s" repeatCount="indefinite" begin="2.8s" />
    <animateMotion dur="6.2s" repeatCount="indefinite" begin="2.8s" rotate="auto"><mpath href="#route-12" /></animateMotion>
  </g>
  <g class="beam" opacity="0">
    <ellipse class="beam-tail-soft" cx="-11.5" cy="0" rx="12.2" ry="2.45"></ellipse>
    <ellipse class="beam-tail-core" cx="-8" cy="0" rx="8.6" ry="1.6"></ellipse>
    <ellipse class="beam-body" cx="-1.7" cy="0" rx="6.2" ry="1.02"></ellipse>
    <circle class="beam-head-glow" cx="3.7" cy="0" r="2.35"></circle>
    <circle class="beam-head-core" cx="4.1" cy="0" r="1.16"></circle>
    <animate attributeName="opacity" values="0;0.82;0.82;0" dur="6.8s" repeatCount="indefinite" begin="3.4s" />
    <animateMotion dur="6.8s" repeatCount="indefinite" begin="3.4s" rotate="auto"><mpath href="#route-13" /></animateMotion>
  </g>
`;

export default function Globe() {
  const wrapRef = useRef();

  useEffect(() => {
    function reposition() {
      const header = document.querySelector('header');
      const footer = document.querySelector('footer');
      if (!header || !footer || !wrapRef.current) return;
      if (window.innerWidth <= 768) return;
      const headerBottom = header.getBoundingClientRect().bottom;
      const footerTop    = footer.getBoundingClientRect().top;
      const center       = headerBottom + (footerTop - headerBottom) / 2;
      wrapRef.current.style.top       = center + 'px';
      wrapRef.current.style.transform = 'translateY(-50%)';
    }

    reposition();
    window.addEventListener('resize', reposition);

    const ro = new ResizeObserver(reposition);
    const header = document.querySelector('header');
    const footer = document.querySelector('footer');
    if (header) ro.observe(header);
    if (footer) ro.observe(footer);

    return () => {
      window.removeEventListener('resize', reposition);
      ro.disconnect();
    };
  }, []);

  return (
    <div ref={wrapRef} className="globe-wrap" aria-hidden="true">
      <svg
        className="globe-svg"
        viewBox="0 0 1792 768"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{ __html: SVG_HTML }}
      />
    </div>
  );
}
